import superModule from "./superModule";
import {GHpLocalPropertyInfo, GHpNormData} from "./httpContent/gameHttpContent";
import O1HD, {services} from "../gameEngine";
import {PLATFORM_CODE} from "../services/ossService";
import User, { releaseData } from "../User";
import NormalGameManager from "../../modes/normalMode/manager/NormalGameManager";
import { getOneHeadUrlById } from "../../modes/normalMode/config/UserHeadConfig";
import data_control from "../libs/data_control";

export default class GameHttpModule extends superModule {
    protected m_className: string = '网络http模块';
    //URL
    private readonly LINDDONG_GAME_SERVER_URL: string = 'https://api.oss.tobetopone.com/countrySystem/';
    private readonly LINGYI_GAME_SERVER_URL:string = 'https://api.tobetopone.com';    
    private readonly RELEASE_URL:string = "https://appcityapi.renyouwangluo.cn/";
    private readonly REPORT_URL:string = "https://appcityapi.renyouwangluo.cn/";

    //URL
    private readonly GAME_SERVER_URL: string = 'https://apple.tobetopone.com';
    // private readonly GAME_SERVER_URL: string = 'http://192.168.0.118:13012';
    user:User = null;

    async loadModule(){
        this.user = new User();
    }

    PingPong(cb: (res: any) => void, errorCb?: (res: GHpNormData) => void) {
        // this.sendHttp(web_api.POST.ping_pong, 'post', null, cb, errorCb);
    }

    /**
     * 获取用户信息
     * @param wxIdentify 唯一标识
     * @param cb
     * @param errorCb
     */
    getUserWebInfo(wxIdentify: string, cb: (res: any) => void, errorCb?: (res: GHpNormData) => void) {

    }

    getLocalPropertyInfo(cb: (res: GHpLocalPropertyInfo) => void, errorCb?: (res: GHpNormData) => void) {
        let resData = <GHpLocalPropertyInfo>{};
        this.sendHttp('/dataCenter/api/ip/getClientInfo', 'get', null, resData, cb, res => {
            console.error('#38 http错误', res);
            errorCb && errorCb(res);
        },true,"lingyi");
    }

    /**
     * 获取远程数据
     */
    getRemotePropertyInfo(
        url : string 
        , params :  { pageNum : number , pageSize : number } 
        , cb: (res: GHpNormData) => void
        , errorCb?: (res: GHpNormData) => void 
    ) {
        let resData = <GHpNormData>{};
        this.sendHttp( url, 'post', params, resData, cb, res => {
            console.error('#38 http错误', res);
            errorCb && errorCb(res);
        });
    }

    private sendKsHttp<T>(router: string,
                          method: string,
                          params: object,
                          resData: T,
                          successCallback: (res: T) => void,
                          errorCallback?: (res: GHpNormData) => void,type:string = "lingdong") {
        method = method.toUpperCase();
        let url = type == "lingdong"? this.LINDDONG_GAME_SERVER_URL + router : this.LINGYI_GAME_SERVER_URL + router;

        const ks = window['ks'];
        if (method == 'POST') {
            ks.request({
                method: method,
                url: url,
                data: params,
                header: {
                    'content-type': 'application/json',
                },
                success: (res) => {
                    console.log('快手状态码', res.statusCode, router,res);
                    successCallback(res.data.data);
                },
                fail: (res) => {
                    errorCallback(res);
                }
            });
        } else {
            console.error('未实现快手的GET请求')
        }
    }
    sendMessage(router:string,method:string="POST",params?:any,successCallback?:Function,errorCallback?:Function){
        let url = this.GAME_SERVER_URL + router;
        let data = null;
        if (!this.isString(params)) {
            for (let k in params) {
                let v = params[k];
                if (data == null) {
                    data = `${k}=${v}`;
                } else {
                    data += `&${k}=${v}`;
                }
            }
        }
        let xhr = new XMLHttpRequest();
        xhr.timeout = 10000;
        xhr.onreadystatechange = () => {
            if (xhr.readyState == XMLHttpRequest.DONE || xhr.readyState ==4) {
                if (xhr.status >= 200 && xhr.status < 300) {
                    let response = xhr.responseText;
                    try {
                        this.onHttpDone(JSON.parse(response), (res) => {
                            console.log(res)
                            successCallback && successCallback(res);
                        }, ()=>{
                            console.log("error");
                        }, xhr);
                    } catch (e) {
                        console.error('运行后端回执引发的异常', response, e);
                    }
                } else {
                    errorCallback && errorCallback(null);
                }
            }
        };
        xhr.ontimeout = () => {
            console.error('请求超时', url);
            errorCallback && errorCallback({code: -1, msg: '请求超时', data: null});
        }
        if (method.toUpperCase() == 'GET' && data) {
            url += `?${data}`;
        }
        xhr.open(method, url, true);
        xhr.setRequestHeader('Content-type', 'application/json');
        if (method.toUpperCase() == 'POST') {
            xhr.send(params);
            // if(this.isString(params)){
            // }else{
            //     // console.log(JSON.stringify(params));
            //     xhr.send(JSON.stringify(params));
            // }
        } else {
            xhr.send();
        }
    }

    isString(param: any): boolean {
        return typeof param === 'string';
      }
      

    /***
     * 发送http条文
     * @param router 无需URL 路径
     * @param method 提交方式 GET POST
     * @param params 参数对象
     * @param resData 返回数据
     * @param successCallback 提交成功
     * @param errorCallback 提交失败
     * @param async 是否异步 - 默认 true
     */
    private sendHttp<T>(router: string,
                        method: string,
                        params: object,
                        resData: T,
                        successCallback: (res: T) => void,
                        errorCallback?: (res: GHpNormData) => void,
                        async = true
                        , type:string = "lingdong"
    ) {
        if (services().ossSrv.getPlatform() == PLATFORM_CODE.KS) {
            this.sendKsHttp(router, method, params, resData, successCallback, errorCallback,type);
            return;
        }
        let url = type == "lingdong"? this.LINDDONG_GAME_SERVER_URL + router 
        : this.LINGYI_GAME_SERVER_URL + router;
        switch(type){
            case "releaseData":{
                url = this.RELEASE_URL + router;
                break;
            }
            case "report":{
                url = this.REPORT_URL + router;
                break;
            }
        }
        console.log(url,"请求地址");
        let data = null;
        if (params) {
            //
            for (let k in params) {
                let v = params[k];
                if (data == null) {
                    data = `${k}=${v}`;
                } else {
                    data += `&${k}=${v}`;
                }
            }
            //
        }
        let xhr = new XMLHttpRequest();
        xhr.timeout = 10000;
        xhr.onreadystatechange = () => {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                if (xhr.status >= 200 && xhr.status < 300) {
                    let response = xhr.responseText;
                    try {
                        this.onHttpDone(JSON.parse(response), (res) => {
                            switch (typeof res) {
                                case "object": {
                                    successCallback(<T>res);
                                    break;
                                }
                                case "string": {
                                    successCallback(<T>JSON.parse(res));
                                    break;
                                }
                            }
                        }, errorCallback, xhr);
                    } catch (e) {
                        console.error('运行后端回执引发的异常', response, e);
                    }
                } else {
                    errorCallback && errorCallback(null);
                }
            }
        };
        xhr.ontimeout = () => {
            console.error('请求超时', url);
            errorCallback && errorCallback({code: -1, msg: '请求超时', data: null});
        }
        if (method.toUpperCase() == 'GET' && data) {
            url += `?${data}`;
        }
        xhr.open(method, url, async);
        xhr.setRequestHeader('Content-type', 'application/json');
        if (method.toUpperCase() == 'POST') {
            console.log("params !!!!!!!!", JSON.stringify(params) );

            xhr.send(JSON.stringify(params));
        } else {
            xhr.send();
        }
    }

    /**
     * @param {HttpData} jsonResponse
     * */
    private onHttpDone(
        jsonResponse: GHpNormData
        , successCallback: (res: any | string) => void
        , errorCallback: (res: GHpNormData) => void
        , xhr: XMLHttpRequest
    ) {
        let {code, msg, data} = jsonResponse;

        if (code != null && code != 0) {
            errorCallback && errorCallback(jsonResponse);
            console.error('错误的回执', jsonResponse);
            return;
        }
        //
        successCallback(data || jsonResponse);
    }
    ttLogin() {
        return new Promise<boolean>((resolve, reject) => {
            const tt = window["tt"];
            if(!tt){
                resolve(true);
                return;
            }
            const self = this;
            tt.login({
                force: true, fail: () => {
                    resolve(false);
                }, success(res) {

                    let releaseData:releaseData = {
                        type:"1",
                    }

                    const body: any = {
                        uid:"",
                        code: res["code"],
                        anonymousCode: res["anonymousCode"]
                    }
                    tt.getUserInfo({
                        withCredentials: true, lang: "", success: (info) => {
                            console.warn('平台登录succeed',info,res);
                            const nickName = info.userInfo.nickName;
                            let code = body.code || body.anonymousCode;
                            let uid:string = res["uid"];
                            let headUrl:string = info["userInfo"]["avatarUrl"];
                            let name:string = nickName;
                            self.user.updateUserDate({_uid:uid,_headUrl:headUrl,_userName:name});
                            releaseData.userName = name;
                            releaseData.city = info["userInfo"]["ciry"];
                            releaseData.portrait = headUrl;
                            releaseData.code = code;
                            self.user.setReleaseData(releaseData);
                            self.sendReleaseData();
                        }, fail: () => {
                            console.warn('平台登录fail', res);
                            self.user.setReleaseData(releaseData);
                            self.sendReleaseData();
                            resolve(false);
                        }
                    });
                }
            });
        });
    }

    releaseUrl:string = "wwmxd/user/userLogin";

    sendReleaseData(){
        let data = this.user.getReleaseData();
        console.log(" sendReleaseData data " , data );

        this.sendHttp(this.releaseUrl,"POST",data,{},res=>{
            console.log("投放登录成功");
            let openid = res['openid'];
            this.user.setReleaseData({openid:openid});
        },res=>{
            console.log("投放登录失败",JSON.stringify(res));
        },true,"releaseData");
    }

    reportUrl:string = "wwmxd/user/userPostTime"

    sendReportMsg(){
        let data = {
            openid:this.user.getReleaseData().openid,
            mp_id:"tt324344fead7f03ff02"
        }
        this.sendHttp(this.reportUrl,"POST",data,{},res=>{
            console.log("上报成功");
        },res=>{
            console.log("上报失败",JSON.stringify(res));
        },true,"report");
    }

    updateUserUrl:string = "api/user/updateUserInfo";

    updateUserInfo(data:{uid:string,username?:string,headImg?:string,unlockSkin?:string,gameMaxScore:number,gameScoreType:number,dyOpenId?:string,dyUnionId?:string,dyProvince?:string,dyCountry?:string}){
        this.sendHttp(this.updateUserUrl,"POST",data,{},res=>{
            console.log("更新用户信息成功")
        },res=>{
            console.error("更新用户信息失败：",res);
        });
    }

    donationUrl:string = "api/donation/donationUpdate";

    //提交捐献分数
    comitDonationCoins(coin:number){
        let d = data_control.getWriteCoins(coin);
        if(O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5){
            d.formats = 0;
            d.num = 0;
        }
        const data = {
            uid:this.user.getUserDate()._uid,
            donationCoins:d.num,
            donationCoinsType:d.formats
        }
        this.sendHttp(this.donationUrl,"POST",data,{},res=>{
            console.log("更新捐献榜成功");
        },res=>{
            console.error("更新捐献榜失败：",res);
        })
    }
}
